
export enum LAYOUT {
  SIX_EQUAL_POINTS = 'six_equal_points',
  NINE_EQUAL_POINTS = 'nine_equal_points',
  TWENTY_FIVE_EQUAL_POINTS = 'twenty_five_equal_points',
  RIGHT_SIDE_LIST = 'right_side_list',
  TOP_SIDE_LIST = 'top_side_list',
  LARGE_SMALL_WINDOW = 'large_small_window',
  GRID_VIEW= 'grid_view',
};

export enum SettingMode {
  SIMPLE = 'simple',
  DETAIL = 'detail',
}
